import { Component, OnInit, OnDestroy } from '@angular/core';
import { SnackbarService } from './service/snackbar.service';
import { Subscription } from 'rxjs';
import { trigger, animate, style, transition } from '@angular/animations';

export class Snack {
  message: string;
  duration: number;
  type: string;
}

@Component({
  selector: 'app-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss'],
  animations: [
    trigger('state' , [
      transition(':enter', [
        style({bottom: '-100px', transform: 'translate(-50%, 0%) scale(0.3)'}),
        animate('150ms cubic-bezier(0, 0, 0.2, 1)', style({
          transform: 'translate(-50%,0%) scale(1)',
          opacity: 1,
          bottom: '20px'
        })),
    ]),
      transition(':leave', [
        animate('150ms cubic-bezier(0.4, 0.0, 1, 1)', style({
          transform: 'translate(-50%,0%) scale(0.3)',
            opacity: 0,
            bottom: '-100px'
        }))
      ])
    ])
  ]
})
export class SnackbarComponent implements OnInit, OnDestroy {

  public positionTopRight = false;
  private snackbarSubscription = new Subscription();
  public snacks = [];

  constructor(private snackbarService: SnackbarService) { }

  ngOnInit() {
    this.snackbarSubscription = this.snackbarService.snackbarState.subscribe(state => {
      if (this.snacks.length >= 3) {
        clearTimeout(this.snacks[2].timeout);
        this.snacks.pop();
      }

      if(state.pos == 'topRight') {
        this.positionTopRight = true;
      }

      if (!state.type) {
        state.type = 'success';
      }
      if (state.time !== 0 && !state.time) {
        state.time = 5;
      }
      if (state.time > 0) {
       state.timeout = setTimeout(() => {
          this.snacks.splice(this.snacks.indexOf(state), 1);
          clearTimeout(state.timeout);
        }, state.time * 1000);
      }
      this.snacks.unshift(state);
    });
  }

  closeSnack(snack) {
    clearTimeout(snack.timeout);
    this.snacks.splice(this.snacks.indexOf(snack), 1);
  }

  ngOnDestroy() {
    this.snackbarSubscription.unsubscribe();
  }

}
